import {computed, ComputedRef} from "vue";
import {BackendFetch, Models, useDialogs} from "@hantera/portal-app";
import EnumFieldEditor from "@/components/EnumFieldEditor";
import {DataColumnValuesEnumSet, DataColumnValuesEnumValue} from "@hantera/design-system";

export default function (
  fetch: BackendFetch,
  graphMeta: Record<string, Models.GraphMeta.GraphNodeMeta>
) {
  
  const dialogs = useDialogs();
  
  return {
    valueSets(nodeName: string, fieldName: string):
      ComputedRef<DataColumnValuesEnumSet[]> {
      
      return computed(() => {
        const node = graphMeta[nodeName]
        if (!node) {
          return []
        }

        const field = node.fields[fieldName]
        if (!field) {
          return []
        }

        let valueType = field.valueType
        if (field.valueType.type === 'array') {
          valueType = field.valueType.itemType
        }
        if (valueType.type !== 'enum') {
          return []
        }
        
        const result: DataColumnValuesEnumSet[] = []
        for (const set of Object.values(valueType.valueSets)) {
          // For now, we always pick the default label. Once portal locale is connected to core locales we can
          // choose the proper locale based on user settings
          const setLabel = set.label['default']
          
          const enumSet = <DataColumnValuesEnumSet>{
            label: setLabel,
            values: []
          }
          result.push(enumSet)
          
          for (const valueKey in set.values) {
            if (!valueKey) {
              continue;
            }
            
            const value = set.values[valueKey]

            // For now, we always pick the default label. Once portal locale is connected to core locales we can
            // choose the proper locale based on user settings
            const label = value.label['default']

            enumSet.values.push({
              key: valueKey,
              label: label,
              hue: value.hue?.toNumber()
            })
          }
        }
        
        return result
      })
    },
    value(nodeName: string, fieldName: string, valueKey: string):
      ComputedRef<DataColumnValuesEnumValue | undefined> {
      
      return computed(() => {
        const node = graphMeta[nodeName]
        if (!node) {
          return
        }
        
        const field = node.fields[fieldName]
        if (!field) {
          return
        }
        
        let valueType = field.valueType
        if (field.valueType.type === 'array') {
          valueType = field.valueType.itemType
        }
        if (valueType.type !== 'enum') {
          return
        }
        
        for (const set of Object.values(valueType.valueSets)) {
          const value = set.values[valueKey]
          if (value) {
            // For now, we always pick the default label. Once portal locale is connected to core locales we can
            // choose the proper locale based on user settings
            const label = value.label['default']
            
            return <DataColumnValuesEnumValue>{
              key: valueKey,
              label: label,
              hue: value.hue
            }
          }
        }
        
      })
    },
    openEditor(nodeName: string, fieldName: string, value?: string) {
      dialogs.openModal(
        'Configure values',
        EnumFieldEditor,
        true,
        {
          fieldKey: `${nodeName}.${fieldName}`,
          value
        }
      );
    }
  }
}
